/* FloorplanTab constants. */

export const THIRD_PARTY = 'third_party'
export const CAR_STORAGE = 'car_storage'
